import styled from 'styled-components';
import { Layout } from '@design-system';

export const GoToSpotifyButtonContainer = styled(Layout.FlexRow)`
  box-shadow: 0px -1px 8px 0px rgba(0, 0, 0, 0.1);
`;
